import { domain } from 'modules/data';

import { EmailToSupplierMessages } from '../../../components/EmailToSupplierForm/EmailToSupplierForm.types';
import { messages } from './QBooksEmailToVendorSection.messages';

export const placeholderList = [
    domain.SupplierEmailReplacements.poNumber,
    domain.SupplierEmailReplacements.totalAmount,
    domain.SupplierEmailReplacements.supplierName,
    domain.SupplierEmailReplacements.companyName,
    domain.SupplierEmailReplacements.contactPersonName,
];

export const labels: Partial<EmailToSupplierMessages> = {
    formTitle: messages.formTitle,
    toggleLabel: messages.toggleLabel,
    attachmentsLabel: messages.attachmentsLabel,
    attachmentsNote: messages.attachmentsNote,
};
